export default {
  DATE: 'MMM d, yyyy',
  TIME: 'h:mm a z',
  DATETIME: 'MMM d, yyyy a h:mm z',
};
